import { Module } from 'vuex';

import { User } from '../../entity/authentication/user';

export interface UserData {
  user: User | null;
  userRole: string | null;
  isAuthenticated: boolean;
}

const defaultState: UserData = {
  user: null,
  userRole: null,
  isAuthenticated: false
};

const userStore: Module<UserData, {}> = {
  state: defaultState,
  mutations: {
    logIn(state, user: User) {
      state.user = user;
      state.userRole = 'ADMIN';
      state.isAuthenticated = true;
    },
    logOut(state) {
      state = defaultState;
    },
  },
  actions: {
    logIn({ commit }, user: User) {
      setTimeout(() => {
        commit('logIn', user);
      }, 50);
    },
    logOut({ commit }) {
      setTimeout(() => {
        commit('logOut');
      }, 50);
    },
  }
};

export default userStore;
